import { defineStore } from "pinia"
import { ref } from 'vue'
import { useApiStore, apiIdOf, API_ORIGIN, axiosRetryx } from "@/stores/api"
import { apiDefaultDescriptions, type ApiOptions } from "@/stores/api"

export const useAccountPreferencesStore = defineStore('accountPreferences', () => {
  const { apiCall, checkResponseError } = useApiStore()

  // トーク通知メールが有効かどうか
  const talkNotificationMailEnabled = ref<boolean>(true)

  // トーク通知メール設定取得API
  const getTalkNotificationMailSetting = async (
    args: { 
      __apiOptions?: ApiOptions
    }
  ) => {
    const apiOptions = args.__apiOptions || {}
    apiOptions.apiId = apiIdOf('getTalkNotificationMailSetting');

    return await apiCall<{ talk_notification_mail_enabled: boolean }>(apiOptions, async (apiConfig) => {
      const url = API_ORIGIN + "/gettalknotificationmailsetting";
      const data = {
      }

      const response = await axiosRetryx({ method: 'post', url, data, ...apiConfig })

      const descriptions = {
        ...apiDefaultDescriptions,
      }

      if (checkResponseError(response, descriptions, apiOptions)) {
        return;
      }
      talkNotificationMailEnabled.value = response.data.talk_notification_mail_enabled
      return { talk_notification_mail_enabled: response.data.talk_notification_mail_enabled };
    })
  }

  // トーク通知メール設定更新API  
  const setTalkNotificationMailSetting = async (
    args: { 
      talk_notification_mail_enabled: boolean
      __apiOptions?: ApiOptions
    }
  ) => {
    const apiOptions = args.__apiOptions || {}
    apiOptions.apiId = apiIdOf('setTalkNotificationMailSetting');

    return await apiCall<'OK'>(apiOptions, async (apiConfig) => {
      const url = API_ORIGIN + "/settalknotificationmailsetting";
      const data = {
        talk_notification_mail_enabled: args.talk_notification_mail_enabled,
      }

      const response = await axiosRetryx({ method: 'post', url, data, ...apiConfig })

      const descriptions = {
        ...apiDefaultDescriptions,
      }

      if (checkResponseError(response, descriptions, apiOptions)) {
        return;
      }
      return 'OK';
    })
  }

  return {
    talkNotificationMailEnabled,
    getTalkNotificationMailSetting,
    setTalkNotificationMailSetting,
  }
})